import React from 'react';

import { ApiUrls } from '../../shared/api-urls';

import { SlLearnEngine } from '../../../features/learnEngine/public/SlLearnEngine/SlLearnEngine';

const configs = {
  soloLearnUrl: ApiUrls.soloLearnUrl,
};
export const LearnEngine = ({ isAiSite }: { isAiSite: boolean; }) => {
  return <SlLearnEngine configs={configs} isAiSite={isAiSite} />;
};
